import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { cn } from "@/lib/utils";

const navLinkCls = cn(
  "text-[13px] font-medium text-text-muted",
  "transition-colors hover:text-text-primary"
);

const bottomBarCls = cn(
  "mt-12 border-t border-border-subtle pt-6"
);

export default function Footer() {
  const { t } = useTranslation("common");
  const year = new Date().getFullYear();

  return (
    <footer
      className={cn(
        "relative z-10 mt-24 border-t border-border-subtle",
        "bg-bg-elevated/40"
      )}
    >
      <div className="mx-auto max-w-[1240px] px-6 py-14 sm:px-8">
        <div
          className={cn(
            "grid gap-10 sm:grid-cols-[1.4fr_1fr_1fr]",
            "sm:items-start"
          )}
        >
          <div>
            <p
              className={cn(
                "font-display text-3xl font-medium tracking-tight",
                "text-text-primary"
              )}
            >
              David Stejskal<span className="text-accent">.</span>
            </p>
            <p className="mt-3 max-w-xs text-sm leading-relaxed text-text-muted">
              {t("footer.tagline")}
            </p>
          </div>

          <div>
            <p className="label-sm mb-3">{t("footer.sections.contact")}</p>
            <a
              href="mailto:david.stejskal@dasteke.com"
              className={cn(
                "block text-[15px] font-medium text-text-primary",
                "transition-colors hover:text-accent"
              )}
            >
              david.stejskal@dasteke.com
            </a>
            <p className="mt-1 text-sm text-text-dim">Brno, Czech Republic</p>
          </div>

          <div>
            <p className="label-sm mb-3">{t("footer.sections.explore")}</p>
            <ul className="space-y-2">
              <li>
                <Link to="/about" className={navLinkCls}>
                  {t("nav.about")}
                </Link>
              </li>
              <li>
                <Link to="/portfolio" className={navLinkCls}>
                  {t("nav.portfolio")}
                </Link>
              </li>
              <li>
                <Link to="/contact" className={navLinkCls}>
                  {t("nav.contact")}
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className={bottomBarCls}>
          <p className="label-sm">
            &copy; {year} David Stejskal - {t("footer.rights")}
          </p>
        </div>
      </div>
    </footer>
  );
}
